import React, { useState, useEffect } from 'react';
import { TextField, Button, Typography, Box } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import API_BASE_URL from '../config';

const ControlPasswordProtected = (WrappedComponent) => {
  return function WithControlPassword(props) {
    const navigate = useNavigate();
    const [isAuthorized, setIsAuthorized] = useState(false);
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [primaryColor, setPrimaryColor] = useState(localStorage.getItem('primaryColor') || '#ffffff');
    const [darkMode, setDarkMode] = useState(localStorage.getItem('darkMode') === 'true');
    const expire = 30;

    useEffect(() => {
      const lastAuthTime = sessionStorage.getItem('controlPasswordAuthTime');
      if (lastAuthTime && (Date.now() - parseInt(lastAuthTime, 10)) < expire * 60 * 1000) {
        setIsAuthorized(true);
      }

      const interval = setInterval(() => {
        setPrimaryColor(localStorage.getItem('primaryColor') || '#ffffff');
        setDarkMode(localStorage.getItem('darkMode') === 'true');
      }, 1000);

      return () => clearInterval(interval);
    }, []);

    const handlePasswordSubmit = async (e) => {
      e.preventDefault();
      try {
        const response = await fetch(`${API_BASE_URL}/users/control-verification/${props.deviceId}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          },
          body: JSON.stringify({ password })
        });

        if (response.status === 401) {
            navigate('/unauthorized');
            return;
          }

        if (response.ok) {
          setIsAuthorized(true);
          sessionStorage.setItem('controlPasswordAuthTime', Date.now().toString());
          setError('');
        } else {
          const errorData = await response.json();
          setError(errorData.message || 'Invalid password. Please try again.');
        }
      } catch (error) {
        console.error('Error during verification:', error);
        setError('An error occurred. Please try again.');
      }
    };

    const textColor = darkMode ? '#ffffff' : '#000000';

    if (!isAuthorized) {
      return (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          height="100vh"
          bgcolor={primaryColor}
          sx={{ transition: 'background-color 0.3s ease' }}
        >
          <Typography variant="h4" gutterBottom style={{ color: textColor }}>
            Enter Control Password
          </Typography>
          <form onSubmit={handlePasswordSubmit}>
            <TextField
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              error={!!error}
              helperText={error}
              fullWidth
              margin="normal"
              variant="outlined"
              sx={{ bgcolor: 'white', mb: 2 }}
            />
            <Button 
              type="submit" 
              variant="contained" 
              fullWidth 
              sx={{ 
                mt: 2, 
                bgcolor: '#4CAF50', 
                '&:hover': { bgcolor: '#45a049' } 
              }}
            >
              Submit
            </Button>
          </form>
          <Typography variant="body2" style={{ color: textColor, marginTop: '20px' }}>
            Note: Control access will expire in {expire} minutes.
          </Typography>
        </Box>
      );
    }

    return <WrappedComponent {...props} />;
  };
};

export default ControlPasswordProtected;